/**
 * Brand mark for AdmissionCrafts.
 *
 * Renders the hexagon logomark + wordmark side by side. The hexagon image
 * lives in /public/logo.png so it's served at the root and can be reused
 * as a favicon, OG image, and inside the app shell.
 */
import { Link } from "react-router-dom";

export default function Logo({
  to = "/",
  size = "md",          // "sm" | "md" | "lg"
  showWordmark = true,
  className = "",
  testId = "brand-logo",
}) {
  const sz =
    size === "sm" ? "h-7 w-7"
    : size === "lg" ? "h-12 w-12"
    : "h-9 w-9";
  const text =
    size === "sm" ? "text-base"
    : size === "lg" ? "text-2xl sm:text-[26px]"
    : "text-[19px] sm:text-[20px]";

  const inner = (
    <>
      <img
        src="/logo.png"
        alt="AdmissionCrafts logo"
        className={`${sz} object-contain select-none drop-shadow-sm`}
        draggable={false}
      />
      {showWordmark && (
        <span className={`font-display ${text} font-bold tracking-tight text-slate-900 group-hover:text-slate-700 transition-colors`}>
          Admission<span className="text-amber-600">Crafts</span>
        </span>
      )}
    </>
  );

  if (!to) {
    return (
      <span className={`inline-flex items-center gap-2 group ${className}`} data-testid={testId}>
        {inner}
      </span>
    );
  }
  return (
    <Link to={to} className={`inline-flex items-center gap-2 group ${className}`} data-testid={testId}>
      {inner}
    </Link>
  );
}
